import React, { useEffect, useState } from "react";

import {
  Grid,
  Divider,
  Typography,
  Button,
  CircularProgress,
} from "@mui/material";
import { Card, CardContent } from "@mui/material";
import axiosClient from "../axiosClient";
import CircleIcon from "@mui/icons-material/Circle";
import axiosClientSevan from "../axiosClientSevan";

import moment from "moment/moment";

const LicenseDetails = () => {
  const [companiesWithStores, setCompaniesWithStores] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    axiosClient
      .get("customer/authenticated")
      .then((response) => {
        axiosClient
          .get("customer/", { params: { email: response.data.customer_email } })
          .then(async (response) => {
            const allStores = response.data.data.Companies.flatMap((company) =>
              company.Stores.map((store) => ({
                companyId: company.id,
                companyName: company.company_name,
                store: store,
              }))
            );

            const responses = await Promise.all(
              allStores.map(async (object) => {
                const sevanPayload = {
                  shop_code: object.store.store_bill_id,
                  service_id: 301,
                  platform_name: "SOFTECH",
                };

                const response = await axiosClientSevan.post(
                  "api/shop/service/exist",
                  sevanPayload
                );
                return { ...object, result: response.data.data };
              })
            );
            setCompaniesWithStores(responses);
            setLoading(false);
          })
          .catch((err) => console.log(err));
      })
      .catch((err) => console.log(err));
  }, []);

  if (loading) {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CircularProgress />
        </Grid>
      </Grid>
    );
  }

  return (
    <div style={{ flexGrow: 1, padding: "20px" }}>
      <Grid container spacing={3}>
        {companiesWithStores.map((company, index) => {
          const serviceWithExpDates = company.result.service_type_data;
          const hasAServiceActive = serviceWithExpDates.filter(
            (obj) => obj.service_type_expriration_Date != "-"
          );

          var active = 1;
          var showActivationLink = 0;

          const currentDate = moment().format('DD-MM-YYYY');
          const expirationDate = moment(hasAServiceActive[0].service_type_expriration_Date,'DD-MM-YYYY');
          const fiveDaysBeforeExpiration = expirationDate.subtract(6, 'days').format('DD-MM-YYYY')

          if (
            moment(currentDate).isAfter(expirationDate)
          ) {
            active = 0;
          }

          if (moment(currentDate).isAfter(fiveDaysBeforeExpiration)) {
            showActivationLink = 1;
          }

          return (
            <Grid item xs={12} md={6} lg={4} key={index}>
              <Card style={{ minWidth: 200, margin: "10px" }}>
                <CardContent>
                  <Typography variant="h6" component="h2">
                    {company.companyName}
                  </Typography>
                  <Divider sx={{ height: 16 }} />
                  <div style={{ marginBottom: "20px" }}>
                    <Typography variant="body2" component="p">
                      {company.store.name}
                    </Typography>
                    <Typography
                      variant="body2"
                      color={showActivationLink ? "red" : "textSecondary"}
                    >
                      Expiration Date:{" "}
                      {hasAServiceActive[0].service_type_expriration_Date}
                      {active ? (
                        <CircleIcon fontSize="12" color="success" />
                      ) : (
                        <CircleIcon fontSize="12" color="error" />
                      )}
                    </Typography>
                    {showActivationLink ? (
                      <Button
                        variant="contained"
                        color="success"
                        onClick={() => {
                          axiosClientSevan.post(`api/check/customer-access`,{
                            shop_code: company.store.store_bill_id,
                            platform_name: "SOFTECH"
                          }).then((res) => {
                            window.open(
                              res.data.data.url,
                              "_blank"
                            );
                          }).catch((err) => console.log(err))
                        }}
                      >
                        Renew here!
                      </Button>
                    ) : null}
                    <Divider sx={{ height: 16 }} />
                  </div>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
};

export default LicenseDetails;
